import React, { useState } from 'react';
import {
  Box,
  TableRow,
  TableCell,
  Collapse,
  CircularProgress,
  Typography,
  TableBody,
  IconButton,
  Table,
  Tooltip,
} from '@material-ui/core';
import Excel from 'assets/icons/svg/Excel';
import moment from 'moment';
import { IPartnerRatingByPartnerUgo, IRealEstateRatingByPartnerUgo } from '../../../interfaces';
import { INomenclature } from '../interfaces';
import ApplicationsByPartnerDialog from './ApplicationsByPartnerDialog';

interface IProps {
  open: boolean;
  nomenclature: INomenclature;
  partnerRating: IPartnerRatingByPartnerUgo;
  realEstatesRating: IRealEstateRatingByPartnerUgo[];
  loading: boolean;
  error: string | null;
  success: boolean;
  exportExcelLoading: boolean;
  criteriaRatingsCount: number;
  onExportExcel(): void;
}

const PartnerRatingByMonthTableRow = ({
  open,
  error,
  loading,
  nomenclature,
  partnerRating,
  realEstatesRating,
  success,
  exportExcelLoading,
  criteriaRatingsCount,
  onExportExcel,
}: IProps) => {
  const [applicationsByPartnerUgoDialogOpened, setApplicationsByPartnerUgoDialogOpened] = useState(false);
  const [selectedRealEstateRating, setSelectedRealEstateRating] = useState<IRealEstateRatingByPartnerUgo | null>(null);

  function handleRowClick(realEstateRating: IRealEstateRatingByPartnerUgo) {
    setSelectedRealEstateRating(realEstateRating);
    setApplicationsByPartnerUgoDialogOpened(true);
  }

  return (
    <Box component={TableRow} sx={{ borderBottom: 'unset' }}>
      <TableCell colSpan={criteriaRatingsCount} style={{ padding: 0, borderBottom: 'unset' }}>
        <Collapse in={open} unmountOnExit>
          {Boolean(loading) ? (
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
              <CircularProgress />
            </Box>
          ) : Boolean(error) && !Boolean(realEstatesRating.length) ? (
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
              <Typography component="h3" variant="h5" align="center">
                {error}
              </Typography>
            </Box>
          ) : (
            success && (
              <>
                {realEstatesRating.length ? (
                  <>
                    <Table size="small" style={{ tableLayout: 'fixed' }}>
                      <TableBody>
                        {realEstatesRating.map((realEstateRating, index) => {
                          const { criteriaRatings, dateAt } = realEstateRating;

                          return (
                            <TableRow key={index}>
                              <TableCell>
                                <b>{moment(dateAt, 'YYYY-MM').format('MMM')}</b>
                              </TableCell>

                              {criteriaRatings.map((criteriaRating, index) => {
                                const foundCriteriaRating = criteriaRatings[index];

                                return (
                                  <TableCell
                                    key={criteriaRating.criteriaRatingId}
                                    align="center"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleRowClick(realEstateRating)}
                                  >
                                    {foundCriteriaRating?.value ?? '—'}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>

                    <ApplicationsByPartnerDialog
                      open={applicationsByPartnerUgoDialogOpened}
                      partnerRating={partnerRating}
                      realEstateRating={selectedRealEstateRating}
                      nomenclature={nomenclature}
                      onClose={() => setApplicationsByPartnerUgoDialogOpened(false)}
                    />
                  </>
                ) : (
                  <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
                    <Typography component="h3" variant="h5" align="center">
                      Данные отсутствуют
                    </Typography>
                  </Box>
                )}

                <Box sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  {Boolean(realEstatesRating.length) && (
                    <Tooltip title="Скачать отчет в Excel">
                      <span>
                        <IconButton
                          aria-label="Скачать отчет в Excel"
                          onClick={onExportExcel}
                          disabled={loading || exportExcelLoading}
                        >
                          <Excel style={{ color: '#3C763D' }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                </Box>
              </>
            )
          )}
        </Collapse>
      </TableCell>
    </Box>
  );
};

export default PartnerRatingByMonthTableRow;
